import { useState } from "react";
import { Img } from "components/Img";

const WebsiteTemplate = ({ element, selectedValue, onChange }) => {
    const [showModal, setShowModal] = useState(false);

    const handleOpenModal = (e) => {
        e.preventDefault(); // Prevent anchor default behavior
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    return (
        <div className="font-manrope w-fit">
            {/* Template Card */}
            <div
                className={`rounded-2xl shadow-lg bg-gray-200 min-h-[35vh] max-h-[35vh] overflow-clip ${selectedValue?.url === element?.url ? "border-2 border-purple-primary" : ""}`}
                onClick={() => onChange(element)}
            >
                <Img
                    src={element?.thumbnail}
                    alt={element?.TEMPLATE_NAME}
                    className="object-cover object-top min-h-[35vh] max-h-[35vh] transform transition-transform duration-300 ease-in-out hover:scale-105 hover:cursor-pointer"
                />
            </div>

            {/* Name and Link */}
            <div className="flex justify-between items-center py-2">
                <p className="font-manropeM">{element?.TEMPLATE_NAME}</p>
                <button
                    type="button"
                    onClick={handleOpenModal}
                    className="inline-flex items-center"
                    title="Preview"
                >
                    <Img src="images/Onboarding/LinkOpeningArrow.svg" alt="Open link" className="h-6" />
                </button>
            </div>

            {/* Fullscreen Modal */}
            {showModal && (
                <div className="fixed top-0 left-0 w-full h-full bg-[white] bg-opacity-80 z-50">
                    {/* Close Button */}
                    <button
                        onClick={handleCloseModal}
                        className="absolute top-4 right-4 z-50 bg-[white] p-2 rounded-full shadow-2xl"
                        aria-label="Close modal"
                    >
                        <Img src="images/Close.svg" alt="Close" className="" />
                    </button>

                    {/* Scrollable Container */}
                    <div className="z-20 w-full h-full overflow-y-auto flex justify-center items-start bg-[white]">
                        <Img
                            src={element?.url}
                            alt={element?.TEMPLATE_NAME}
                            className="z-20 max-w-full h-auto pointer-events-none"
                        />
                    </div>
                </div>
            )}

        </div>
    );
};

export default WebsiteTemplate;
